import request from "root/js/request";

export const getAnalyticsProductsForSelectorsAdvert = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  limit = 100,
  offset = 0,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/products-for-selectors/advert/",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};

